import { render, staticRenderFns } from "./yiBaoTongOrderAfterSale.vue?vue&type=template&id=5ad05e26"
import script from "./yiBaoTongOrderAfterSale.vue?vue&type=script&lang=js"
export * from "./yiBaoTongOrderAfterSale.vue?vue&type=script&lang=js"
import style0 from "./yiBaoTongOrderAfterSale.vue?vue&type=style&index=0&id=5ad05e26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports